module.exports = __webpack_public_path__ + "img/编辑.e352326b.svg";